// Institute of Design and Innovation (email idi@unm.edu). //

import { createApp } from 'vue'
import Layout from './Layout.vue'
import httpClient from './common/httpClient'
import router from './router/router'
import store from './store/store'
import avComps from '@aetherial/aetherial-vue/avComponents.umd.js'
import { hasPermissionDirective, isAdminDirective } from '@/directives/auth-directives'
import OspPermissionValues from './models/permissions'
import Maska from 'maska'

// Styles
require('@/styles/application.scss')

const app = createApp(Layout)
app.config.globalProperties.$axios = httpClient
app.config.globalProperties.$permissions = OspPermissionValues
app.use(avComps)
app.directive('has-permission', hasPermissionDirective)
app.directive('is-admin', isAdminDirective)
app.use(Maska)

/**
 * sets up main page
 */
setTimeout(() => {
  app.use(store).use(router).mount('body')
}, 0)
